import {NgModule, ModuleWithProviders} from '@angular/core';
import {NgbProgressbar} from './progressbar';
import {NgbProgressbarConfig} from './progressbar-config';

export {NgbProgressbar} from './progressbar';
export {NgbProgressbarConfig} from './progressbar-config';


export class NgbProgressbarModule {
  static forRoot(): ModuleWithProviders { return {ngModule: NgbProgressbarModule, providers: [NgbProgressbarConfig]}; }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{declarations: [NgbProgressbar], exports: [NgbProgressbar]}, ] },
];
/** @nocollapse */
static ctorParameters: ({type: any, decorators?: DecoratorInvocation[]}|null)[] = [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
